<template>
    <div>
        <div class="mb-5 mr-4 ml-4">
            <BuscarBaseComponent :front="false" id="paso-0" :paso_activo="paso0_activo" :base="base_search" :error="error" @terminado="buscarBase"></BuscarBaseComponent>
        </div>

        <PasoUnoComponent id="paso-1" :paso_activo="paso1_activo" v-if="paso1" :base="base" @terminado="terminarPasoUno()" @volver="volverPasoCero()"/><br><br><br>
        <PasoDosComponent id="paso-2" :paso_activo="paso2_activo" v-if="paso2" :base="base" @terminado="terminarPasoDos()" @volver="volverPasoUno()"/><br><br><br>
        <PasoTresComponent id="paso-3" v-if="paso3" :base="base"/>
    </div>
</template>

<script>
import BuscarBaseComponent from "@/components/frontend/bases/renovar/BuscarBaseComponent.vue";
import PasoUnoComponent from "@/components/backend/bases/components/PasoUnoComponent";
import PasoDosComponent from "@/components/backend/bases/components/PasoDosComponent";
import PasoTresComponent from "@/components/backend/bases/components/PasoSeisComponent";

export default {
    data() {
        return {
            paso0: true,
            paso0_activo: true,
            paso1: false,
            paso1_activo: false,
            paso2: false,
            paso2_activo: false,
            paso3: false,
            base_search: {
                dni: null,
            },
            base: null,
            error: false,
            loading: false
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
    },
    methods: {
        buscarBase() {
            this.loading = true;

            const params = {
                filters: {
                    tid: this.configuracion.hash_teatro,
                    dni: this.base_search.dni
                },
            }

            this.$store.dispatch(this.config.getVuexAlias('front.bases.buscar'), params).then(res => {
                this.base = res.data.base;
                this.terminarPasoCero();
            }).catch(error => {
                this.error = error.response.data.message;
            }).finally(() => this.loading = false);
        },
        scrollTo(paso) {
            this.$scrollTo(paso, 100);
        },
        terminarPasoCero() {
            this.paso0_activo = false;
            this.paso1 = true;
            this.paso1_activo = true,
            this.error = null;
            this.$nextTick(() => {
                this.scrollTo('#paso-1');
            });                
        },
        volverPasoCero() {
            this.paso0_activo = true;
            this.paso1 = false;
            this.paso1_activo = false,
            this.$nextTick(() => {
                this.scrollTo('#paso-0');
            });
        },
        terminarPasoUno() {
            this.paso2 = true;
            this.paso2_activo = true;
            this.paso1_activo = false,
            this.$nextTick(() => {
                this.scrollTo('#paso-2');
            });                
        },
        volverPasoUno() {
            this.paso2 = false;
            this.paso2_activo = false,
            this.paso1_activo = true,
            this.$nextTick(() => {
                this.scrollTo('#paso-1');
            });
        },
        terminarPasoDos() {
            this.paso3 = true;
            this.paso2_activo = false,
            this.$nextTick(() => {
                this.scrollTo('#paso-3');
            });                
        }
    },
    components: { 
        BuscarBaseComponent,
        PasoUnoComponent,
        PasoDosComponent,
        PasoTresComponent
    }
}
</script>